import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { TenantProvider } from './context/TenantContext';
import { FrontDeskAuthProvider } from './context/FrontDeskAuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';

// FrontDesk (público)
import FrontDesk  from './pages/frontdesk/FrontDesk';
import RequestHome from './pages/frontdesk/RequestHome';
import TrackTicket from './pages/frontdesk/TrackTicket';
import SurveyPage from './pages/SurveyPage';
import LoanRequest from './pages/frontdesk/LoanRequest';

// BackDesk (protegido)
import Login from './pages/backdesk/Login';
import Dashboard from './pages/backdesk/Dashboard';
import TicketList from './pages/backdesk/TicketList';
import TicketDetail from './pages/backdesk/TicketDetail';
import Agents     from './pages/backdesk/Agents';
import SLAConfig  from './pages/backdesk/SLAConfig';
import Computers       from './pages/backdesk/Computers';
import ComputerDetail  from './pages/backdesk/ComputerDetail';
import SurveyResults   from './pages/backdesk/SurveyResults';
import Clients         from './pages/backdesk/Clients';
import Departments        from './pages/backdesk/Departments';
import Calendar           from './pages/backdesk/Calendar';
import ExtensionsPage     from './pages/frontdesk/ExtensionsPage';
import ExtensionsManager  from './pages/backdesk/ExtensionsManager';
import RoomsPage          from './pages/rooms/RoomsPage';
import RoomsManager       from './pages/backdesk/RoomsManager';
import LoansManager       from './pages/backdesk/LoansManager';
import ReportsPage        from './pages/backdesk/ReportsPage';
import SuperAdminPage     from './pages/superadmin/SuperAdminPage';
import SuperAdminLogin    from './pages/superadmin/SuperAdminLogin';

export default function App() {
  return (
    <TenantProvider>
    <FrontDeskAuthProvider>
    <AuthProvider>
      <Routes>
        {/* FrontDesk — público */}
        <Route path="/"              element={<RequestHome />} />
        <Route path="/nuevo-ticket"  element={<FrontDesk />} />
        <Route path="/ticket/:ref"   element={<TrackTicket />} />
        <Route path="/survey/:token" element={<SurveyPage />} />
        <Route path="/extensions"    element={<ExtensionsPage />} />
        <Route path="/rooms"         element={<RoomsPage />} />
        <Route path="/loans"         element={<LoanRequest />} />

        {/* Auth */}
        <Route path="/login" element={<Login />} />

        {/* BackDesk — protegido */}
        <Route path="/backdesk" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/backdesk/tickets" element={<ProtectedRoute><TicketList /></ProtectedRoute>} />
        <Route path="/backdesk/tickets/:id" element={<ProtectedRoute><TicketDetail /></ProtectedRoute>} />
        <Route path="/backdesk/agents" element={<ProtectedRoute><Agents /></ProtectedRoute>} />
        <Route path="/backdesk/sla"        element={<ProtectedRoute><SLAConfig  /></ProtectedRoute>} />
        <Route path="/backdesk/computers"      element={<ProtectedRoute><Computers       /></ProtectedRoute>} />
        <Route path="/backdesk/computers/:id" element={<ProtectedRoute><ComputerDetail /></ProtectedRoute>} />
        <Route path="/backdesk/surveys"      element={<ProtectedRoute><SurveyResults  /></ProtectedRoute>} />
        <Route path="/backdesk/clients"      element={<ProtectedRoute><Clients        /></ProtectedRoute>} />
        <Route path="/backdesk/departments"  element={<ProtectedRoute><Departments       /></ProtectedRoute>} />
        <Route path="/backdesk/calendar"     element={<ProtectedRoute><Calendar          /></ProtectedRoute>} />
        <Route path="/backdesk/extensions"   element={<ProtectedRoute><ExtensionsManager /></ProtectedRoute>} />
        <Route path="/backdesk/rooms"        element={<ProtectedRoute><RoomsManager     /></ProtectedRoute>} />
        <Route path="/backdesk/loans"        element={<ProtectedRoute><LoansManager     /></ProtectedRoute>} />
        <Route path="/backdesk/reports"      element={<ProtectedRoute><ReportsPage      /></ProtectedRoute>} />
        <Route path="/superadmin/login"       element={<SuperAdminLogin />} />
        <Route path="/superadmin"            element={<ProtectedRoute allowRoles={['superadmin','admin']}><SuperAdminPage   /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
    </FrontDeskAuthProvider>
    </TenantProvider>
  );
}
